import React from 'react';
import _ from 'lodash';
import { useParameterizedQuery, useMutation } from 'react-fetching-library';
import { Button, Menu, MenuItem, Divider, ListItem, ListItemIcon, ListItemText, ListItemButton, ListItemSecondaryAction, IconButton, Tooltip, Box, Checkbox, Stack, Typography } from '@mui/material';
import { deleteEmployeeAgrementAction, createEmployeeAnnexAction, createEmployeeAgrementAction, sendEmployeeDocument, deleteEmployeeAnnexAction, updateAgreementAction, updateAgreementAnnexAction } from '../../../../../../services/request';

import AddIcon from '@mui/icons-material/Add';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import RefreshIcon from '@mui/icons-material/Refresh';
import Iconify from '../../../../../../components/Iconify';

import SendMessagePreviewModal from './SendMessagePreviewModal';
import ConfirmRefreshAgreementModal from './ConfirmRefreshAgreementModal';
import ConfirmUnsignAgreementModal from './ConfirmUnsingAgreementModal';
import { ConfirmDialog } from '../../../../../../components/ConfirmDialog';
import { useApplication } from '../../../ApplicationsContext';
import toast from 'react-hot-toast';
import BrushIcon from '@mui/icons-material/Brush';
import { formatDateTime } from '../../../../../../services/functions';
import { functions } from '../../../functions';
import { useSelector } from 'react-redux';

const AgreementButton = ({ formik, getDocument, module }) => {
  const { rowData, setRowData } = useApplication();
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);
  const [openRefreshModal, setOpenRefreshModal] = React.useState(false);
  const [openUnsignModal, setOpenUnsignModal] = React.useState(false);
  const [refreshType, setRefreshType] = React.useState('');
  const [unsignType, setUnsignType] = React.useState('');
  const [previewModalData, setPreviewModalData] = React.useState({ handleSend: () => { }, type: '', fileNames: [] });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState({});
  const [confirmCreateAgreement, setConfirmCreateAgreement] = React.useState(false);
  const { query: sendAgreementAnnex } = useParameterizedQuery(sendEmployeeDocument);
  const { seasonIdentifier } = useSelector((state => state.app));

  const open = Boolean(anchorEl);

  const { query: queryAgreement } = useParameterizedQuery(createEmployeeAgrementAction);
  const { query: queryAnnex } = useParameterizedQuery(createEmployeeAnnexAction);
  const { mutate: mutateDeleteAgreement } = useMutation(deleteEmployeeAgrementAction);
  const { mutate: mutateDeleteAnnex } = useMutation(deleteEmployeeAnnexAction);
  const { mutate: mutateUpdateAgreement } = useMutation(updateAgreementAction);
  const { mutate: mutateUpdateAgreementAnnex } = useMutation(updateAgreementAnnexAction);

  const application = formik.values;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenCreateAgreementConfirmation = () => {
    if (rowData.questionnaire_state !== 'filled') {
      setConfirmCreateAgreement(true);
    } else {
      handleCreateAgreement();
    }
  };
  const handleCreateAgreement = async () => {
    if ((_.isEmpty(rowData.zs_timed_periods) && rowData.periods_type == 'zielone_szkoly') || (_.isEmpty(rowData.ol_timed_periods) && rowData.periods_type == 'obozy')) {
      toast.error('Sekcja "zatrudniony w terminach" musi zostać wypełniona');
    } else {
      const { payload, error, loading } = await queryAgreement(application.id);
      if (!error && !loading) {
        formik.setFieldValue('agreement_number', payload.agreement_number);
        toast.success('Utworzono umowę');
      }

      if (error) {
        toast.error('Nie udało się utworzyć umowy');
      }
    }
  };

  const handleCreateAnnex = async () => {
    // if ((_.isEmpty(rowData.zs_timed_periods) && rowData.periods_type == 'zielone_szkoly') || (_.isEmpty(rowData.ol_timed_periods) && rowData.periods_type == 'obozy')) {
    //   toast.error('Sekcja "zatrudniony w terminach" musi zostać wypełniona');
    // } else if (_.isNil(rowData.works_in_additional_periods)) {
    // if (_.isNil(rowData.works_in_additional_periods)) {
    //   toast.error('Pole "świadczy / nie świadczy usług w dodatkowych terminach" musi zostać uzupełnione');
    // } else {
    const { payload, error, loading } = await queryAnnex(application.id);
    if (!error && !loading) {
      formik.setFieldValue('application_annexes', payload.application_annexes);
      toast.success('Utworzono aneks');
    }
    if (error) {
      toast.error('Nie udało się utworzyć aneksu');
    }
    // }
  };


  const handleConfirmDelete = (annexId, type) => {
    setConfirmDeleteOpen(true);
    if (type == 'aneks') {
      setDeleteData({ id: annexId, type: 'aneks' });
    } else if (type == 'umowa') {
      setDeleteData({ id: null, type: 'umowa' });
    }
  };

  const handleDeleteAnnex = async () => {
    const { error: mutateError } = await mutateDeleteAnnex(application.id);
    if (!mutateError) {
      formik.setFieldValue('application_annexes', application.application_annexes.filter(annex => annex.id !== deleteData.id));
      toast.success('Aneks został usunięty');
    } else {
      toast.error('Nie udało się usunąć aneksu');
    }
    setConfirmDeleteOpen(false);
    setDeleteData({});
  };

  const handleDeleteAgreement = async () => {
    const { payload, error: mutateError } = await mutateDeleteAgreement(application.id);
    if (!mutateError) {
      formik.setFieldValue('agreement_number', '');
      toast.success('Umowa została usunięta');
    } else {
      toast.error('Nie udało się usunąć umowy');
    }
    setConfirmDeleteOpen(false);
    setDeleteData({});
  };

  const handleSendAgreement = async data => {
    const { error, loading } = await sendAgreementAnnex(application.id, 'agreement', data, `Umowa nr ${application.agreement_number}`);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać aneksu');
    }
  };

  const handleSendAnnex = async (annex_nr, data) => {
    const { error, loading } = await sendAgreementAnnex(application.id, 'annex', data, annex_nr);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać aneksu');
    }
  };

  const handleOpenPreviewModal = (handleSend, type, fileNames) => {
    setPreviewModalData({ handleSend, type, fileNames });
    setOpenPreviewModal(true);
  };

  const handleClosePreviewModal = () => setOpenPreviewModal(false);

  // const handleConfirmAnnexReturn = async (e, id) => {
  //   const { error, payload } = await updateAnnex(id, { 'annex_return': e.target.checked });
  //   if (!error) {
  //     console.log(payload);
  //     dispatch(updateOrder({ ...order, order_annexes: order.order_annexes.map(annex => annex.id === id ? payload : annex) }));
  //     if (e.target.checked === true) {
  //       handleOpenSnackbar('success', 'Zwrot został zaznaczony');
  //     } else {
  //       handleOpenSnackbar('success', 'Zwrot został odznaczony');
  //     }
  //   } else {
  //     // eslint-disable-next-line no-lonely-if
  //     if (e.target.checked === true) {
  //       handleOpenSnackbar('error', 'Nie udało się zaznaczyć zwrotu');
  //     } else {
  //       handleOpenSnackbar('error', 'Nie udało się odznaczyć zwrotu');
  //     }
  //   }
  // };
  const isAgreementReturned = () => rowData && rowData.checkbox_sections ? rowData.checkbox_sections.find(section => section.name == 'UMOWA').items.find(item => item.type == 2).value : false;

  const handleChangeIsSentToDGCS = async (agreementAnnexId = null) => {
    let newValue = null;
    let annexes = [];
    let idx = null;
    if (agreementAnnexId) {
      annexes = rowData.application_annexes;
      idx = _.findIndex(annexes, obj => obj.id == agreementAnnexId);
      newValue = !annexes[idx].is_sent_to_dgcs;
    } else {
      newValue = !rowData.is_agreement_sent_to_dgcs;
    }
    const { error, loading } = agreementAnnexId ? await mutateUpdateAgreementAnnex(agreementAnnexId, { is_sent_to_dgcs: newValue }) : await mutateUpdateAgreement(rowData.agreement_id, { is_sent_to_dgcs: newValue });
    if (!error && !loading) {
      toast.success('Zmieniono wartość pola wysłano do DGCS');
      if (agreementAnnexId) {
        annexes[idx] = { ...annexes[idx], is_sent_to_dgcs: !annexes[idx].is_sent_to_dgcs };
        setRowData(prev => ({ ...prev, application_annexes: annexes }));
      } else {
        setRowData(prev => ({ ...prev, is_agreement_sent_to_dgcs: newValue }));
      }
    }

    if (error) {
      toast.error('Nie udało się zmienić wartości pola wysłano do DGCS');
    }
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="contained"
      // disabled={application.state !== 'CON'}
      >
        Umowa lub ostatni aneks
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem
          onClick={application.agreement_number !== '' ? handleCreateAnnex : handleOpenCreateAgreementConfirmation}
          disabled={rowData.questionnaire_state === 'sent' ||
            seasonIdentifier == 'l_23_rekrutacja' ||
            (application.agreement_number && application.function_type == functions.INSTRUCTORASSIST)}
        >
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText>
            {application.agreement_number === ''
              ? 'Dodaj umowe'
              : 'Dodaj aneks'}
          </ListItemText>
        </MenuItem>
        <Divider />
        {application.agreement_number !== ''
          ? <ListItem sx={{ pr: '274px' }} disablePadding>
            <ListItemButton
              onClick={() => getDocument('agreement', `Umowa nr ${application.agreement_number}`)}
            >
              <ListItemText>{application.agreement_number}</ListItemText>
            </ListItemButton>
            <ListItemSecondaryAction sx={{ width: '250px', display: 'flex', flexDirection: 'row', justifyContent: 'left', gap: 1 }}>
              <IconButton edge="end" aria-label="comments" onClick={() => getDocument('agreement', 'umowa', 0, true)}>
                <RemoveRedEyeIcon color="primary" />
              </IconButton>
              {application.application_annexes.length === 0
                ? <>
                  <IconButton edge="end" aria-label="comments" onClick={() => handleConfirmDelete(null, 'umowa')} disabled={seasonIdentifier == 'l_23_rekrutacja'}>
                    <DeleteIcon color="error" />
                  </IconButton>
                  <Tooltip title="wyślij dokument do klienta" placement="right-start">
                    <IconButton
                      edge="end"
                      aria-label="comments"
                      onClick={() => handleOpenPreviewModal(handleSendAgreement, 'SAGR', [`${application.agreement_number}`])}>
                      <ForwardToInboxIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <IconButton edge="end" aria-label="comments" disabled={isAgreementReturned() || seasonIdentifier == 'l_23_rekrutacja'} onClick={() => {
                    setOpenRefreshModal(true);
                    setRefreshType('agreement');
                  }}>
                    <RefreshIcon color={isAgreementReturned() ? '#808080' : 'secondary'} />
                  </IconButton>
                  <Tooltip title="usuń podpis" placement="right-start">
                    <IconButton edge="end" aria-label="comments" disabled={!isAgreementReturned()} onClick={() => {
                      setOpenUnsignModal(true);
                      setUnsignType('agreement');
                    }}>
                      <Iconify icon="mdi:eraser" style="color:#3366FF" />
                    </IconButton>
                  </Tooltip>
                </>
                : null}
              <Tooltip title="Wysłano do DGCS">
                <span>
                  <Checkbox
                    id="is_agreement_sent_to_dgcs"
                    name=""
                    checked={rowData.is_agreement_sent_to_dgcs}
                    onChange={() => handleChangeIsSentToDGCS()}
                    disabled={rowData.is_agreement_sent_to_dgcs || seasonIdentifier == 'l_23_rekrutacja' } />
                </span>
              </Tooltip>
              {rowData.agreement_is_signed && <Stack justifyContent="center" alignItems="center">
                <Tooltip title={`Umowa podpisana elektronicznie dnia ${formatDateTime(rowData.agreement_signing_date)}`}>
                  <BrushIcon color="secondary" />
                </Tooltip>
              </Stack>}
            </ListItemSecondaryAction>
          </ListItem>
          : null}

        {application.application_annexes.map((annex, index) => (
          <ListItem
            key={annex.id}
            sx={{ pr: '274px' }}
            disablePadding
          >
            <ListItemButton
              onClick={() => getDocument('annex', `Aneks nr ${annex.number} do umowy ${application.agreement_number}`, annex.number)}
            >
              <ListItemText>Aneks nr {annex.number}</ListItemText>
            </ListItemButton>
            <ListItemSecondaryAction sx={{ width: '250px', display: 'flex', flexDirection: 'row', justifyContent: 'left', gap: 1 }}>
              <IconButton edge="end" aria-label="comments" onClick={() => getDocument('annex', `Aneks nr ${annex.number} do umowy ${application.agreement_number}`, annex.number, true)}>
                <RemoveRedEyeIcon color="primary" />
              </IconButton>
              {index === application.application_annexes.length - 1
                ? <>
                  <IconButton edge="end" aria-label="comments" onClick={() => handleConfirmDelete(annex.id, 'aneks')} disabled={ seasonIdentifier == 'l_23_rekrutacja'}>
                    <DeleteIcon color="error" />
                  </IconButton>
                  <Tooltip title="wyślij dokument do klienta" placement="right-start">
                    <IconButton
                      edge="end"
                      aria-label="comments"
                      onClick={() => handleOpenPreviewModal(data => handleSendAnnex(annex.number, data),
                        [
                          functions.INSTRUCTORASSIST,
                          functions.PHOTOGRAPHER,
                          functions.PHOTOGRAPHER_ZS
                        ].includes(Number(application.function_type))
                          ? 'SSOD'
                          : 'SANS',
                        [`Aneks nr ${annex.number} do umowy ${application.agreement_number}`])}>
                      <ForwardToInboxIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </>
                : null}
              <Tooltip title="Wysłano do DGCS">
                <Checkbox id="is_sent_to_dgcs" name="" checked={annex.is_sent_to_dgcs} onChange={() => handleChangeIsSentToDGCS(annex.id)} disabled={annex.is_sent_to_dgcs} />
              </Tooltip>
              {annex.is_signed && <Stack justifyContent="center" alignItems="center" ml={index === application.application_annexes.length - 1 ? 0 : 1}>
                <Tooltip title={`Aneks podpisany elektronicznie dnia ${formatDateTime(annex.signing_date)}`}>
                  <BrushIcon color="secondary" />
                </Tooltip>
              </Stack>}
              {/* <Tooltip title="zwrot aneksu" placement="right-start">
                <Checkbox edge="end" checked={annex.annex_return} onChange={e => handleConfirmAnnexReturn(e, annex.id)}></Checkbox>
              </Tooltip> */}
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </Menu>
      {openPreviewModal
        ? <SendMessagePreviewModal
          handleSend={previewModalData.handleSend}
          handleClose={handleClosePreviewModal}
          fileNames={previewModalData.fileNames}
          type={previewModalData.type} />
        : null}
      {openRefreshModal ? <ConfirmRefreshAgreementModal handleClose={() => setOpenRefreshModal(false)} application={application} type={refreshType} /> : null}
      {openUnsignModal ? <ConfirmUnsignAgreementModal handleClose={() => setOpenUnsignModal(false)} application={application} type={unsignType} /> : null}
      <ConfirmDialog
        title={deleteData.type == 'umowa' ? 'Czy na pewno chcesz usunąć tę umowę?' : 'Czy na pewno chcesz usunąć ten aneks?'}
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={deleteData.type == 'umowa' ? handleDeleteAgreement : handleDeleteAnnex}
      >
        Czy na pewno chcesz dokonać tej zmiany? <p></p><b style={{ fontSize: 18, color: 'red' }}>Zostanie ona automatycznie zapisana</b>
      </ConfirmDialog>
      <ConfirmDialog
        title="Kwestionariusz nie został jeszcze wysłany."
        open={confirmCreateAgreement}
        setOpen={setConfirmCreateAgreement}
        onConfirm={handleCreateAgreement}
      >
        Czy na pewno chcesz utworzyć umowę? Kwestionariusz nie został jeszcze wysłany
      </ConfirmDialog>
    </>
  );
};


export default AgreementButton;
